class CollectionFilters extends HTMLElement {
  constructor() {
    super();

    this.filterButtons = this.querySelectorAll('button');
    this.activeCollectionHandle = this.dataset.activeCollection;
    this.sectionId = this.dataset.sectionId;
    this.collectionContainer = document.querySelector('[data-collection]');
    this.productsContainer = document.querySelector('[data-collection-products]');
  }

  connectedCallback() {
    if (!this.filterButtons.length) {
      console.error('No filter buttons found inside collection-filters.');
      return;
    }

    this.initializeActiveButton();
    this.attachEventListeners();
  }

  initializeActiveButton() {
    this.filterButtons.forEach((button) => {
      const buttonCollectionHandle = button.dataset.collectionHandle;

      if (buttonCollectionHandle === this.activeCollectionHandle) {
        button.classList.add('active');
        button.disabled = true;
      }
    });
  }

  attachEventListeners() {
    this.filterButtons.forEach((button) => {
      button.addEventListener('click', async () => {
        const selectedHandle = button.dataset.collectionHandle;
        await this.loadCollection(selectedHandle);
      });
    });
  }

  async loadCollection(collectionHandle) {
    if(!this.sectionId) throw new Error('Attribute sectionId not found!');

    try {
      this.setLoadingState(true);

      const url = `/collections/${collectionHandle}`;

      const [productsRes, bannerRes] = await Promise.all([
        fetch(`${url}?section_id=${this.sectionId}`),
        fetch(`${url}?section_id=collection-hero`)
      ]);

      const productsHtml = await productsRes.text();
      const bannerHtml = await bannerRes.text();

      if (!productsHtml) throw new Error('Products section HTML not found in response.');

      const parser = new DOMParser();

      const productsDoc = parser.parseFromString(productsHtml, "text/html");

      const newProductsHeading = productsDoc.querySelector('.collection__heading');
      if (newProductsHeading) {
        document.querySelector('.collection__heading')?.replaceWith(newProductsHeading);
      }

      const newProductsContent = productsDoc.querySelector('[data-collection-products]');
      if (!newProductsContent) throw new Error('Element with [data-collection-products] not found in section.');

      this.productsContainer.innerHTML = newProductsContent.innerHTML;

      if (bannerHtml) {
        const bannerDoc = parser.parseFromString(bannerHtml, "text/html");
        const newBanner = bannerDoc.querySelector("[data-banner-section]");
        const oldBanner = document.querySelector("[data-banner-section]");

        if (oldBanner && newBanner) {
          oldBanner.replaceWith(newBanner);
        }
      }

      if (typeof this.updateActiveButton === 'function') {
        this.updateActiveButton(collectionHandle);
      }

      history.replaceState({}, '', url);

    } catch (error) {
      console.error('CollectionFilters fetch error:', error);
    } finally {
      this.setLoadingState(false);
    }
  }

  setLoadingState(isLoading) {
    if (isLoading) {
      document.body.classList.add('request--pending');
    } else {
      document.body.classList.remove('request--pending');
    }
  }

  updateActiveButton(activeHandle) {
    this.filterButtons.forEach((button) => {
      const buttonHandle = button.dataset.collectionHandle;

      const isActive = buttonHandle === activeHandle;
      button.classList.toggle('active', isActive);
      button.disabled = isActive;
    });
  }
}

if (!customElements.get('collection-filters')) {
  customElements.define('collection-filters', CollectionFilters);
}
